module.exports = __webpack_public_path__ + "img/3-image3.a3de18c1.png";